export default __webpack_public_path__ + "static/media/ladak1.412194de.jpg";